import { render, staticRenderFns } from "./AssignCertificateModal.vue?vue&type=template&id=54e18be6&scoped=true&"
import script from "./AssignCertificateModal.vue?vue&type=script&lang=js&"
export * from "./AssignCertificateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e18be6",
  null
  
)

export default component.exports